import Tag from '@preqin/ui-components/cjs/core/Tag';

import { ReportTitleProps } from './types';

import styles from './ReportTitle.module.scss';

export const ReportTitle = ({ title, isBetaTagEnabled }: ReportTitleProps) => {
  return (
    <div className={styles.title}>
      <div className={styles.titleWrapper}>
        <h1>{title}</h1>
      </div>
      {isBetaTagEnabled && (
        <div className={styles.tag}>
          <Tag label="Beta" size="large" type="warning" maxWidth={100} />
        </div>
      )}
    </div>
  );
};
